
import React, { createContext, useState } from "react";

export const ContractContext = createContext();
const ContractContextProvider = ({ children }) => {
    const [show,setShow] = useState(true)
    const [discountValue,setDiscountValue]=useState(0)
      const [code, setCode] = useState("");
      const [discountType, setDiscountType] = useState("");
      const [discount, setDiscount] = useState("");
      const [checkout, setCheckOut] = useState(false);
      const [checkoutRental, setCheckOutRental] = useState(false);




  return (
    <ContractContext.Provider
      value={{
        show,setShow,discountValue,setDiscountValue,code, setCode,discountType, setDiscountType,discount, setDiscount,checkout, setCheckOut,checkoutRental, setCheckOutRental
      }}
    >
      {children}
    </ContractContext.Provider>
  );
};
export default ContractContextProvider;
